import { UserStore } from '../../common/types';
import { LOCALES } from '../../assets/translations';

const UserInitialState: UserStore = {
  locale: LOCALES[0],
  config: undefined,
};

export default UserInitialState;
